import React, { useContext, useEffect, useState, useMemo } from 'react'
import { Col, Row, Form } from 'react-bootstrap'
import { DesignContext } from '../../../../../contexts/DesignContext'
import httpClient from '../../../../../utility/httpClient.util'
import objectPath from 'object-path'
import Select from 'react-select'

const Field = ({
  fieldSelected = {},
  setFieldSelected,
  collection,
  setCollection,
  condition = 'showField',
}) => {
  const designContext = useContext(DesignContext)
  const { jsonForm, findUischemaIndex, findUiSchema } = designContext

  const pageFormCollection =
    objectPath.get(jsonForm, 'pageFormCollection') || {}
  const [form, setForm] = useState({})

  const getForm = async () => {
    let formDesignId = pageFormCollection.formDesignId
    if (!formDesignId) return []
    let api = `/designer/form-design/${formDesignId}`
    let response = await httpClient
      .get(api)
      .then(({ data }) => data.data)
      .catch(() => {})
    return response
  }

  useEffect(async () => {
    let data = await getForm()
    setForm(data)
  }, [pageFormCollection.formDesignId])

  const schema = objectPath.get(form, 'jsonData.schema')
  const uischema = objectPath.get(form, 'jsonData.uischema')
  const collectionMap = objectPath.get(form, 'jsonData.collection.map') || {}
  const schemaField = objectPath.get(schema, 'mapField') || {}
  const collectionFormData = objectPath.get(schema, 'mapFormData') || {}
  const collectionJsonKey =
    objectPath.get(form, 'jsonData.collection.jsonKey') || {}
  const mapKey = objectPath.get(schema, 'mapKey') || {}
  const mapName = objectPath.get(schema, 'mapName') || {}
  const mapField = objectPath.get(schema, 'mapField') || {}

  const collectionOption = useMemo(() => {
    let options = Object.keys(collectionMap) || []
    let collectionOption = options.map((option) => {
      option = { value: option, label: collectionMap[option] }
      return option
    })
    return collectionOption
  }, [collectionMap])

  const getElement = (key) => {
    let mapKey = schema.mapKey[key]
    let elements = uischema.elements
    let indices = findUischemaIndex(key, mapKey, uischema.elements)
    let newElements = findUiSchema(elements, indices)
    return newElements
  }

  const CollectionSelect = () => {
    return (
      <>
        <Col sm="12" className="mt-2">
          <Form.Label>เลือก Collection</Form.Label>
        </Col>
        <Col sm="12">
          <Select
            type="select"
            isClearable
            placeholder="Collection Name"
            options={collectionOption}
            onChange={(option) => setCollection(option?.value)}
            name="collectionName"
            value={collectionOption.find(
              (option) => option.value === collection
            )}
          ></Select>
        </Col>
      </>
    )
  }

  const getFieldOptions = (options) => {
    if (options.length === 0) return []
    let fieldOptions = []
    let groupOptions = []
    options.forEach((optionKey) => {
      if (!collectionFormData[optionKey]) return
      let option = {}
      if (collectionJsonKey[optionKey]) {
        option = { collection: collectionJsonKey[optionKey] || '' }
      }
      if (schemaField[optionKey]) {
        let element = getElement(optionKey)
        option = {
          ...option,
          hasElement: true,
          value: optionKey,
          name: element.name,
          key: optionKey,
          label: mapField[optionKey],
          mapName: mapName[optionKey],
          showField: true,
          showColumn: true,
          tagname: element.tagname,
        }
        if (element.input) {
          option = {
            ...option,
            enableInput: element.enableInput,
            input: element.input,
          }
        }
      } else {
        let mainKey = mapKey[optionKey].split('.')
        mainKey.pop()
        let groupKey = mainKey.pop()
        let element = getElement(groupKey)
        if (element.tagname === 'checkboxGroup') {
          let foundGroup = groupOptions.findIndex(
            (item) => item.key === groupKey
          )
          let list = element.options || []
          if (foundGroup === -1) {
            let groupOption = {
              ...option,
              hasElement: true,
              value: groupKey,
              name: element.name,
              key: groupKey,
              label: element.fieldName,
              mapName: element.name,
              showField: true,
              showColumn: false,
              element: list,
              tagname: element.tagname,
            }
            groupOptions.push(groupOption)
            fieldOptions.push(groupOption)
          }
          let found = list.find(
            (item) =>
              item.key === optionKey ||
              objectPath.get(item, 'input.key') === optionKey
          )
          if (found) {
            if (found.enableInput && found.input.key === optionKey) {
              let input = found.input
              option = {
                ...option,
                hasGroupKey: true,
                enableInput: true,
                groupKey: groupKey,
                value: optionKey,
                name: input.name,
                key: input.key,
                label: [element.fieldName, input.field].join('/'),
                mapName: mapName[optionKey],
                showField: false,
                showColumn: true,
              }
            } else {
              option = {
                ...option,
                hasGroupKey: true,
                enableInput: false,
                groupKey: groupKey,
                value: optionKey,
                name: found.name,
                key: found.key,
                label: [element.fieldName, found.label].join('/'),
                element: found,
                mapName: mapName[optionKey],
                showField: false,
                showColumn: true,
              }
            }
          } else {
            option = null
          }
        }
        if (element.tagname === 'checkboxInput') {
          if (element.input && element.input.key === optionKey) {
            let input = element.input
            option = {
              ...option,
              hasGroupKey: true,
              enableInput: true,
              groupKey: groupKey,
              value: optionKey,
              name: input.name,
              key: input.key,
              label: [element.fieldName, input.field].join('/'),
              mapName: mapName[input.key],
              showField: false,
              showColumn: true,
            }
          }
        }
      }

      if (option) {
        fieldOptions.push(option)
      }
    })
    return fieldOptions
  }

  const FieldCollectionOption = useMemo(() => {
    let jsonMap = objectPath.get(form, 'jsonData.map')
    if (!jsonMap) return []
    let options = Object.keys(collectionJsonKey)
    let fieldOptions = getFieldOptions(options)
    console.log('fieldOptions', fieldOptions)
    fieldOptions.sort((a, b) => {
      let aName = a?.mapName || ''
      let bName = b?.mapName || ''
      return aName.localeCompare(bName)
    })
    return fieldOptions
  }, [schema])

  const FieldCollectionSelect = () => {
    return (
      <>
        <Col sm="12" className="mt-2">
          <Form.Label>เลือก Field ในระบบ</Form.Label>
        </Col>
        <Col sm="12">
          <Select
            type="select"
            isClearable
            placeholder="Field ในระบบ"
            options={FieldCollectionOption.filter(
              (option) =>
                option?.collection.startsWith(collection) && option[condition]
            )}
            onChange={(option) => setFieldSelected(option)}
            name="fieldKey"
            value={fieldSelected}
          ></Select>
        </Col>
      </>
    )
  }

  const MapName = () => {
    return (
      <>
        <Col sm="12" className="mt-2">
          <Form.Label>Key</Form.Label>
        </Col>
        <Col sm="12">
          <Form.Control
            type="text"
            autoComplete="off"
            value={mapName[fieldSelected?.key]}
            readOnly
          />
        </Col>
      </>
    )
  }

  const FieldSystemOption = useMemo(() => {
    let options = Object.keys(collectionFormData)

    let fieldOptions = getFieldOptions(options)
    fieldOptions.sort((a, b) => {
      let aName = a?.mapName || ''
      let bName = b?.mapName || ''
      return aName.localeCompare(bName)
    })
    return fieldOptions
  }, [schema])

  const FieldSystemSelect = () => {
    return (
      <>
        <Col sm="12" className="mt-2">
          <Form.Label>เลือก Field ในระบบ</Form.Label>
        </Col>
        <Col sm="12">
          <Select
            type="select"
            isClearable
            placeholder="Field ในระบบ"
            options={FieldSystemOption.filter((option) => option[condition])}
            onChange={(option) => {
              setFieldSelected(option)
            }}
            name="fieldKey"
            value={fieldSelected}
          ></Select>
        </Col>
      </>
    )
  }

  return (
    <Row>
      <Col sm="12">
        <Form.Label>ชื่อ Form</Form.Label>
      </Col>
      <Col sm="12">
        <Form.Control
          type="text"
          autoComplete="off"
          value={pageFormCollection.formName}
          readOnly
        />
      </Col>
      {collectionOption.length > 0 && <CollectionSelect />}
      {collection ? <FieldCollectionSelect /> : <FieldSystemSelect />}
      {fieldSelected && <MapName />}
    </Row>
  )
}

export default Field
